import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    pterigion: [],
  },

  getters: {
    getPterigion: (state) => state.pterigion,
  },

  mutations: {
    SET_PTERIGION(state, pterigion) {
      state.pterigion = pterigion;
    },
  },

  actions: {
    async fetchPterigion({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catPterigion')
        .then((response) => {
          commit('SET_PTERIGION', response.data.data);
        });
    },
  },
};
